import { io } from "socket.io-client";

class WebSocketClient {
  constructor() {
    this.socket = null;
    this.messageHandlers = [];
    this.connectionHandlers = [];
    this.disconnectionHandlers = [];
  }

  connect() {
    const socketURL =
      window.location.hostname === 'localhost'
        ? 'http://localhost:5000' // your local backend
        : 'https://squareecommerce-production.up.railway.app'; // production backend

    console.log(`Connecting to WebSocket at ${socketURL}`);

    this.socket = io(socketURL, {
      path: '/socket.io',
      transports: ['polling', 'websocket'], // ✅ must include 'polling'
      reconnection: true,
      reconnectionAttempts: Infinity,
      reconnectionDelayMax: 10000,
      timeout: 20000,
    });

    this.socket.on('connect', () => {
      console.log('✅ Connected to WebSocket server!', this.socket.id);
      this.connectionHandlers.forEach(handler => handler());
    });

    this.socket.on('disconnect', (reason) => {
      console.warn('⚠️ Disconnected from WebSocket server:', reason);
      this.disconnectionHandlers.forEach(handler => handler(reason));
    });

    this.socket.on('connect_error', (error) => {
      console.error('❌ WebSocket connection error:', error.message);
    });

    this.socket.on('message', (message) => {
      console.log('📩 Message received:', message);
      this.messageHandlers.forEach(handler => handler(message));
    });
  }

  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
    }
  }

  sendMessage(message) {
    if (this.socket && this.socket.connected) {
      this.socket.emit('message', message);
      return true;
    } else {
      console.error('🚫 Cannot send message: WebSocket not connected');
      return false;
    }
  }

  onMessage(handler) {
    this.messageHandlers.push(handler);
  }

  onConnection(handler) {
    this.connectionHandlers.push(handler);
    if (this.socket && this.socket.connected) {
      handler();
    }
  }

  onDisconnection(handler) {
    this.disconnectionHandlers.push(handler);
  }

  isConnected() {
    return this.socket && this.socket.connected;
  }
}

const webSocketClient = new WebSocketClient();
export default webSocketClient;
